import PrefectureForm from "../components/PrefectureForm";
import service from "../../../../@services"
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";


const PrefectureDetail = (props => {
    const { search } = useLocation()
    console.log(search,".search")
    const [id] = useState(search.split("id=")[1])
    const [defaultValue, setDefaultValue] = useState({})
    const fn = () => {
        props.history.go(-1)
    }
    useEffect(() => {
        id && service.prefecture.mallZoneDetail(id).then(res => {
            setDefaultValue(res)
        })
    }, [id])
    return (
        <PrefectureForm action="detail" title='专区详情' fn={fn} defaultValue={defaultValue} id={id} />
    );
})

export default PrefectureDetail